export default __webpack_public_path__ + "static/media/go_action.692b7951.svg";